<div class="container-fluid maap-add-user" style="padding-bottom: 100px;">
  <div class="row p-3">
    <div class="col-12">
    </div>
  </div>
  <div class="row p-3">

    <div class="col-12 card mb-2">
      <div class="card-body">
        <h6 class="card-title" style="text-decoration: underline; font-weight: bold;">Account Details</h6>
        <div class="row">
          <div class="col-12">
            <form #accountDetailsForm="ngForm" class="form-inline">
              <div class="row">
                <div class="col-3">
                  <div class="form-group mr-2">
                    <label style="font-weight: 600;">Full Name: <span class="required-indicator">*</span> </label>
                    <input  [(ngModel)]="scope.fullname" required name="fullname" type="text" class="form-control"
                      placeholder="" (ngModelChange)="onFieldChange()">
                  </div>
                </div>
                <div class="col-3">
                  <div class="form-group mr-2">
                    <label style="font-weight: 600;">Email (Username): <span class="required-indicator">*</span> </label>
                    <input  [(ngModel)]="scope.email" [disabled]="!['',null].includes(scope.id)" required name="email"
                      type="text" inputmode="email" class="form-control" placeholder="" (ngModelChange)="onFieldChange()">
                    <small class="font-italic">Note: Your email will be your user name</small>
                  </div>
                </div>
                <div *ngIf="versionType==='legacy'" class="col-4">
                  <div class="form-group mr-2">
                    <label style="font-weight: 600;">Pin: <span class="required-indicator">*</span> </label>
                    <input [required]="[null,''].includes(this.scope.id)" [(ngModel)]="scope.pincode" name="pincode" maxlength="6" max="6" type="text" inputmode="numeric"
                      class="form-control ml-2" placeholder="" (keyup)="validateForm()">
                    <small class="ml-3 font-italic">Note:Please enter 6 digit number</small>
                  </div>
                </div>
                <div class="col-2">
                  <div class="form-group mr-2">
                    <label style="font-weight: 600;">Select Role:</label>
                    <!-- <div class="form-group"> -->
                    <select [(ngModel)]="this.scope.role" name="userRole" class="form-control" (change)="roleUpdated()">
                      <option *ngFor="let option of roles" [value]="option.value">{{option.label}}</option>
                    </select>
                    <!-- </div> -->
                  </div>
                </div>
              
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>

    <div class="col-12 card mb-2">
      <div class="card-body">
        <h6 class="card-title" style="text-decoration: underline; font-weight: bold;">Access Management</h6>
        <div class="row">
          <div class="col-12">
            <app-location-select 
              [user]="user" 
              [filter]="locationFilter"
              (locationSelected)="onLocationSelectionChanged($event)"
              (initComplete)="onLocationSelectInitialized($event)">
            </app-location-select>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 card mb-2">
      <div class="card-body">
        <h6 class="card-title" style="text-decoration: underline; font-weight: bold;">Module Access</h6>
        <div class="row">
          <div class="col-12">
            <div tabindex="0" class="module-access-item" (click)="toggleModule('auditor')" (keydown.enter)="toggleModule('auditor')">
              <span class="material-symbols-rounded module-access-icon" [style.opacity]="scope.auditor ? 1 : 0.45" aria-hidden="true">gpp_maybe</span>
              <label>
                Risk Assessment
                <i *ngIf="scope.auditor" class="pi pi-check checkmark-icon"></i>
              </label>
            </div>
            <div tabindex="0" class="module-access-item" (click)="toggleModule('insights')" (keydown.enter)="toggleModule('insights')">
              <span class="material-symbols-rounded module-access-icon" [style.opacity]="scope.insights ? 1 : 0.45" aria-hidden="true">leaderboard</span>
              <label>
                Enterprise Insights
                <i *ngIf="scope.insights" class="pi pi-check checkmark-icon"></i>
              </label>
            </div>
            <div tabindex="0" class="module-access-item" (click)="toggleModule('variance')" (keydown.enter)="toggleModule('variance')">
              <span class="material-symbols-rounded module-access-icon" [style.opacity]="scope.variance ? 1 : 0.45" aria-hidden="true">flag_circle</span>
              <label>
                Variance
                <i *ngIf="scope.variance" class="pi pi-check checkmark-icon"></i>
              </label>
            </div>
            <div tabindex="0" class="module-access-item" (click)="toggleModule('p2p')" (keydown.enter)="toggleModule('p2p')">
              <span class="material-symbols-rounded module-access-icon" [style.opacity]="scope.p2p ? 1 : 0.45" aria-hidden="true">groups</span>
              <label>
                Peer Analytics
                <i *ngIf="scope.p2p" class="pi pi-check checkmark-icon"></i>
              </label>
            </div>
            <div tabindex="0" class="module-access-item" (click)="toggleModule('waste')" (keydown.enter)="toggleModule('waste')" *ngIf="enableAssayManagement">
              <span class="material-symbols-rounded module-access-icon" [style.opacity]="scope.waste ? 1 : 0.45" aria-hidden="true">biotech</span>
              <label>
                Assay Management
                <i *ngIf="scope.waste" class="pi pi-check checkmark-icon"></i>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-md-12 card-body">
      <div class="row p-4">
      <div class="col-8 card-title">
        <h6 style="text-decoration: underline; font-weight: bold;">Account Settings</h6>
      </div>
        <!-- <div class="col-8">
          <div>
            <input type="checkbox" name="groupname" [(ngModel)]="scope.canRecieveUserUpdates">
            <label class="form-check-label ml-2">Enable notification on user creation/deletion</label>
          </div>
        </div> -->
        <div class="col-8">
          <div>
            <p-checkbox [(ngModel)]="scope.deactivated" [binary]="true" (ngModelChange)="onSettingChange()"></p-checkbox>
            <label class="form-check-label ml-3" style="margin-left: 10px;">Deactivated</label>
          </div>
        </div>
        <div *ngIf="isCameraLoginEnabled && versionType==='legacy'"  class="col-8">
          <div>
            <p-checkbox [(ngModel)]="scope.enableCameraLogin" [binary]="true" (ngModelChange)="onSettingChange()"></p-checkbox>
            <label class="form-check-label ml-2">Enable Camera Login</label>
          </div>
        </div>
        <div *ngIf="versionType!=='legacy'"  class="col-8" style="display: none">
          <div>
            <p-checkbox [(ngModel)]="scope.readOnly" [binary]="true" (ngModelChange)="onSettingChange()"></p-checkbox>
            <label class="form-check-label ml-2">Limit to Read-Only Access</label>
          </div>
        </div>
        <div *ngIf="env ==='mayo-uat' || env === 'dev' "  class="col-8" style="margin-top: 5px;">
          <div>
            <p-checkbox [(ngModel)]="scope.deIdUser" [binary]="true" (ngModelChange)="onSettingChange()"></p-checkbox>
            <label class="form-check-label ml-3" style="margin-left: 10px;">Limit this user to only viewing in Deidentified Mode (also limits some capabilities in the app)</label>
          </div>
        </div>
      </div>
      <div *ngIf="isUpdate; else updateUser" class="col-12" style="display: flex; justify-content: flex-end; gap: 8px;">
        <p-button label="Cancel" styleClass="p-button-sm" (click)="cancelEdit()"></p-button>
        <p-button label="Reset Location Permissions" styleClass="p-button-sm" (click)="resetAccessPermissions()"></p-button>
        <p-button label="Save" styleClass="p-button-sm" 
          [disabled]="!canSave()" 
          (click)="saveUser()">
        </p-button>
      </div>
      <ng-template #updateUser>
        <div class="col-12" style="display: flex; justify-content: flex-end; gap: 8px;">
          <p-button label="Cancel" styleClass="p-button-sm" (click)="cancelEdit()"></p-button>
          <p-button label="Reset Location Permissions" styleClass="p-button-sm" (click)="resetAccessPermissions()"></p-button>
          <p-button label="Save" styleClass="p-button-sm" [disabled]="!canSave()" (click)="saveUser()"></p-button>
        </div>
      </ng-template>
    </div>
  </div>
</div>
<p-dialog [header]="msg.title" [(visible)]="showmsgdialog" (onHide)="closeErrorDialog()">
  {{msg.details}}
</p-dialog>
